import React, {FC, useLayoutEffect, useMemo, useRef} from 'react';
import ThumbnailCardContent from 'botframework-webchat/lib/adaptiveCards/Attachment/ThumbnailCardContent';
import { useButtonsClassesEffect } from '../hooks/useButtonsClassesEffect';
import classNames from 'classnames';

const ThumbnailCardWrapper: FC<{attachment: any, disabled: boolean}> = ({attachment, disabled}) => {
    const wrRef = useRef<HTMLDivElement>(null);
   
    const { content, content: { buttons, images, subtitle, text, description }} = attachment;
    const hasButtons = !!buttons?.length;
    const hasImages = !!images?.length;
    const hasText = !!subtitle || !!text || !!description;
    const isRichCard = hasButtons === hasImages ? hasButtons : hasText; // a minimum of two conditions are met
    const className = useMemo(
        () => classNames(isRichCard && 'druid-thumbnail-card__rich', !isRichCard && hasButtons && 'druid-thumbnail-card__buttons-only', !isRichCard && hasImages && 'druid-thumbnail-card__icons-only', !isRichCard && hasText && 'druid-thumbnail-card__text-only')
    , [hasButtons, hasImages, hasText, isRichCard]);


    useButtonsClassesEffect({wrRef, attachment});

    useLayoutEffect(() => { // add druid decorators. only druid-hero-card__buttons-only is used for now.
        wrRef.current?.parentElement?.classList.add(className);
    }, [className]);
    return (
    <div ref={wrRef}>
        <ThumbnailCardContent
                actionPerformedClassName="card__action--performed"
                content={content}
                disabled={disabled}
            >
        </ThumbnailCardContent>
    </div>);
}

export default ThumbnailCardWrapper;